export const skeletonSizes = {
  title: { width: 120, height: 24 },
  input: { width: '100%', height: 56 },
  textArea: { width: '100%', height: 96 },
}
